import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Card, CardActionArea, CardContent, CardHeader, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PersonIcon from '@mui/icons-material/Person';
import PaidIcon from '@mui/icons-material/Paid';
import EventNoteIcon from '@mui/icons-material/EventNote';
import BadgeIcon from '@mui/icons-material/Badge';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import PhoneIcon from '@mui/icons-material/Phone';
import { message } from 'antd';

function parseNumber(str) {
  if (!str) return 0;
  return Number(str.toString().replace(/,/g, ''));
}

function formatCurrency(value) {
  if (value === null || value === undefined) return '0.00';
  let numValue;
  if (typeof value === 'string') {
    numValue = parseFloat(value.replace(/,/g, ''));
  } else if (typeof value === 'number') {
    numValue = value;
  } else {
    return '0.00';
  }
  return value.toLocaleString('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function formattedNumber(value) {
  let number = parseNumber(value);
  return formatCurrency(number);
}

function ViewPendingInvoices() {
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  const getPendingInvoices = async () => {
    try {
      const response = await fetch(`https://dprincess-training.servehttp.com/invoices/list-by-payment-status/pendiente`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        for (const invoice of data) {
          let paidAmount = 0;
          let reservationPaid = [];
          for (const details of invoice.invoiceDetails) {
            paidAmount += parseNumber(details.amount);
            if (details.serviceID === 24) {
              details.amount = parseNumber(details.amount);
              reservationPaid.push(details);
            }
          }
          invoice.pendingAmount = parseNumber(invoice.totalAmount) - paidAmount;
          invoice.paidAmount = paidAmount;
          invoice.reservationPaid = reservationPaid;
        }
        setPendingInvoices(data);
      } else {
        messageApi.open({
          type: 'error',
          content: 'Error al cargar las facturas pendientes, recargue la página.',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      messageApi.open({
        type: 'error',
        content: 'Error al cargar las facturas pendientes, recargue la página.',
      });
    }
  }

  useEffect(() => {
    getPendingInvoices();
  }, []);

  return (
    <div style={{ background: '#f3e8ff', minHeight: '90vh', overflow: 'auto' }}>
      <Container
        sx={{
          padding: '32px 0',
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
        }}
        maxWidth="lg"
      >
        {contextHolder}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '90%' }}>
          <Typography
            variant="h4"
            sx={{
              marginBottom: '28px',
              color: '#4b0082',
              fontWeight: 700,
              letterSpacing: '0.5px',
              textAlign: 'center',
            }}
          >
            Facturas Pendientes
          </Typography>
          {pendingInvoices.length > 0 ? pendingInvoices.map((invoice, index) => (
            <Grid container spacing={1} key={index} sx={{ marginBottom: '24px', justifyContent: 'center' }}>
              <Grid item xs={12} md={10}>
                <Card
                  sx={{
                    width: "100%",
                    borderRadius: '18px',
                    border: '1.5px solid #f759ab',
                    boxShadow: '0 4px 16px 0 rgba(247,89,171,0.10)',
                    background: 'linear-gradient(90deg, #fff 80%, #f3e8ff 100%)',
                    transition: 'box-shadow 0.2s',
                    '&:hover': {
                      boxShadow: '0 8px 32px 0 rgba(247,89,171,0.18)',
                      borderColor: '#f759ab'
                    }
                  }}
                >
                  <CardHeader
                    title={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                        <ReceiptLongIcon sx={{ color: '#f759ab', fontSize: 32, mr: 1 }} />
                        <Box>
                          <Typography
                            sx={{
                              color: '#4b0082',
                              fontWeight: 700,
                              fontSize: '1.15rem',
                              m: 0,
                              lineHeight: 1.2
                            }}
                            component="div"
                          >
                            Facturado a {invoice.clientName}
                          </Typography>
                          <Typography
                            sx={{
                              color: '#7c3aed',
                              fontWeight: 500,
                              fontSize: '0.95rem',
                              mt: 0.5
                            }}
                            component="div"
                          >
                            Número de facturación: <span style={{ fontWeight: 700 }}>{invoice.invoiceNumber}</span>
                          </Typography>
                        </Box>
                      </Box>
                    }
                    sx={{ pb: 0, pt: 2, px: 3, background: '#f8f0fc', borderTopLeftRadius: 18, borderTopRightRadius: 18 }}
                  />
                  <CardContent sx={{ pt: 2, pb: 2, px: 3 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <PersonIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Cliente: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.clientName}</span>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <SmartphoneIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Celular: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.cellphoneNumber}</span>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <PhoneIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Teléfono: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.phoneNumber}</span>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <BadgeIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Atendido por: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.employeeName}</span>
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <ReceiptIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Total facturado: <span style={{ color: '#4b0082', fontWeight: 700 }}>{formatCurrency(parseNumber(invoice.totalAmount))}</span>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <PaidIcon sx={{ color: '#22c55e', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Total pagado: <span style={{ color: '#4b0082', fontWeight: 700 }}>{formatCurrency(parseNumber(invoice.paidAmount))}</span>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <ReceiptIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Pendiente por pagar: <span style={{ color: '#d97706', fontWeight: 700 }}>{formatCurrency(parseNumber(invoice.pendingAmount))}</span>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                          <EventNoteIcon sx={{ color: '#f759ab', mr: 1 }} />
                          <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                            Fecha de facturación: <span style={{ color: '#4b0082', fontWeight: 700 }}>
                              {invoice.invoiceDate
                                ? new Date(invoice.invoiceDate).toLocaleString('es-DO', {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                })
                                : 'No registrada'}
                            </span>
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    <Box sx={{ width: '100%' }}>
                      <Accordion sx={{ borderRadius: '8px', width: '100%' }}>
                        <CardActionArea
                          sx={{
                            mt: 3,
                            background: '#f759ab',
                            color: '#fff',
                            transition: 'background 0.2s',
                            '&:hover': { background: '#e04897' },
                            boxShadow: '0 2px 8px 0 rgba(247,89,171,0.10)'
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ArrowDropDownIcon sx={{ fontWeight: 700, margin: 0, padding: 0, color: '#fff' }} />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 0, m: 0 }}>
                              <Typography variant="body2" sx={{ fontWeight: 700, margin: 0, padding: 0 }}>
                                Ver detalles de la factura
                              </Typography>
                            </Box>
                          </AccordionSummary>
                        </CardActionArea>
                        <AccordionDetails sx={{ padding: 0, margin: 0, width: '100%', display: 'flex', flexDirection: 'column' }}>
                          <Box sx={{ display: 'flex', py: 1, flexDirection: 'column', width: '100%' }}>
                            <ItemDetails invoice={invoice} index={index} />
                            <Button sx={{ mt: 2, background: '#f3e8ff', color: '#4b0082', borderRadius: '8px', padding: '8px 16px', '&:hover': { background: '#e9d5ff' } }} 
                              onClick={() => navigate(`/events/view-event-details/${invoice.eventID}`)}>
                              <EventNoteIcon sx={{ color: '#4b0082', mr: 1 }} />
                              <Typography variant="body2" sx={{ fontWeight: 700, color: '#4b0082' }}>
                                Ver detalles del evento
                              </Typography>
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )) : (
            <Typography variant="h6" sx={{ color: '#4b0082', mt: 4 }}>
              No hay facturas pendientes.
            </Typography>
          )}
        </Box>
      </Container>
    </div>
  )
};

function ReservationDetails({ invoice }) {
  return (
    <Container sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <Typography
          variant="h5"
          sx={{
            marginBottom: '28px',
            color: '#4b0082',
            fontWeight: 700,
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Detalles del evento
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Evento: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.eventTitle}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Lugar: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.eventLocation}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Fecha de inicio: <span style={{ color: '#4b0082', fontWeight: 700 }}>{
                invoice.eventDateStart ? new Date(invoice.eventDateStart).toLocaleString('es-DO', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
                })
                  : 'No registrada'}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Fecha de finalización: <span style={{ color: '#4b0082', fontWeight: 700 }}>{
                invoice.eventDateEnd ? new Date(invoice.eventDateEnd).toLocaleString('es-DO', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
                })
                  : 'No registrada'}</span>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

function ItemDetails({ invoice, index }) {
  return (
    <Container sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <Typography
          variant="h5"
          sx={{
            marginBottom: '28px',
            color: '#4b0082',
            fontWeight: 700,
            letterSpacing: '0.5px',
            textAlign: 'center',
            marginTop: '28px'
          }}
        >
          Detalles de la factura
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Servicio: <span style={{ color: '#4b0082', fontWeight: 700 }}>{invoice.comboName}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Precio: <span style={{ color: '#4b0082', fontWeight: 700 }}>{formattedNumber(invoice.comboPrice)}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Cantidad: <span style={{ color: '#4b0082', fontWeight: 700 }}>1</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Total pagado: <span style={{ color: '#4b0082', fontWeight: 700 }}>
                {invoice.reservationPaid && invoice.reservationPaid.length > 0
                  ? invoice.reservationPaid.length === 1
                    ? `${formattedNumber(invoice.reservationPaid[0].amount)}`
                    : `${formattedNumber(invoice.reservationPaid.reduce((sum, payment) => sum + parseNumber(payment.amount), 0))}`
                  : 'RD$0.00'
                }
              </span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Pendiente por pagar: <span style={{ color: '#4b0082', fontWeight: 700 }}>{formattedNumber(parseNumber(invoice.comboPrice) - invoice.reservationPaid.reduce((sum, payment) => sum + parseNumber(payment.amount), 0))}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
              Estado de pago: <span style={{ color: '#d97706', fontWeight: 700 }}>{invoice.reservationPaid[0].paymentStatus.toUpperCase()}</span>
            </Typography>
          </Grid>
        </Grid>
        {
          invoice.invoiceDetails && invoice.invoiceDetails.length > 0 && invoice.invoiceDetails.map((detail, index) => detail.serviceID !== 24 && (
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                  Servicio: <span style={{ color: '#4b0082', fontWeight: 700 }}>{detail.serviceName}</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                  Precio: <span style={{ color: '#4b0082', fontWeight: 700 }}>{(detail.servicePrice > 0 ? formattedNumber(detail.servicePrice) : formattedNumber((parseNumber(detail.price)) * parseNumber(detail.serviceQty)))}</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                  Cantidad: <span style={{ color: '#4b0082', fontWeight: 700 }}>{detail.serviceQty}</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                  Total pagado: <span style={{ color: '#4b0082', fontWeight: 700 }}>{formattedNumber(detail.amount)}</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                  Pendiente por pagar: <span style={{ color: '#4b0082', fontWeight: 700 }}>
                    {formattedNumber(((detail.servicePrice > 0 ? formattedNumber(detail.servicePrice) : parseNumber(detail.price))*parseNumber(detail.serviceQty)) - parseNumber(detail.amount))}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                  Estado de pago: <span style={{ color: '#d97706', fontWeight: 700 }}>{detail.paymentStatus.toUpperCase()}</span>
                </Typography>
              </Grid>
            </Grid>
          ))
        }
      </Box>
    </Container>
  )
}

export default ViewPendingInvoices